import DropdownStore from "./DropdownStore";
import DropdownInstControl from './DropdownInstControl';
import { ActiveDataType, BtnType, IDropdownBtnConfig, StateType } from "../interface/IDropdown";

export default class DropdownBtn {
    private btnEle: HTMLButtonElement | null = null;
    private btnType: BtnType;
    private useSelectExceptPc: boolean;
    private btnShowDepthLength: number;
    private store: DropdownStore;

    constructor({parent, btnType, useSelectExceptPc, btnShowDepthLength, store}: IDropdownBtnConfig) {
        this.btnType = btnType || 'no-border';
        this.useSelectExceptPc = useSelectExceptPc;
        this.btnShowDepthLength = btnShowDepthLength;
        this.store = store;

        this.init(parent);
    }

    private init(parent: Element) {
        parent?.insertAdjacentHTML('afterbegin', this.template());

        this.btnEle = parent?.querySelector('.dropdown-btn');
        this.addEvent();

        this.store.addListener('isOpen', (isOpen: boolean) => {
            this.active(isOpen);
        });

        this.store.addListener('activeKey', (activeKey: string) => {
            const { activeData, isLastDepth } = this.store.state;

            // 마지막 뎁스값 선택 시
            if(isLastDepth) {
                this.setValue(activeData, this.btnShowDepthLength);
            }
        });
    }

    private template(): string {
        let template = '';

        template += `
            <div class="dropdown-btn-wrap ${this.btnType} ${this.useSelectExceptPc && this.store.state.maxDepth === 1 ? 'only-pc' : ''}">
                <button type="button" class="dropdown-btn">
                    <strong class="dropdown-btn__text">선택하세요</strong>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="dropdown-btn__icon" width="16" height="16" viewBox="0 0 16 16">
                        <path d="m3.76 6.23.7-.7L8 9.06l3.54-3.53.7.7L8 10.47 3.76 6.23z"></path>
                    </svg>
                </button>
            </div>
        `;

        return template;
    }

    private addEvent() {
        this.btnEle?.addEventListener('click', (e: MouseEvent) => {
            const curIsOpen = this.store.state.isOpen;
            if(!curIsOpen) {
                DropdownInstControl.closeOpenDropdown(); // 현재 Dropdown을 열 때, 열려있는 다른 Dropdown 닫음
            }
            this.store.dispatch<'isOpen', StateType['isOpen']>('isOpen', !curIsOpen);
        });
    }

    /*
        버튼 스타일 활성화
        @param {boolean} isOpen dropdown layer 오픈 여부
    */
    active(isOpen: boolean) {
        const $parent = this.btnEle?.parentElement;
        
        if(isOpen) $parent?.classList?.add('is-active');
        else $parent?.classList?.remove('is-active');
    }

    /*
        버튼명 변경
        - btnShowDepthLength: 0이면 모든 뎁스 value 노출, 그 외에는 해당 뎁스 value 노출
        @param {ActiveDataType} activeData 활성화하려는 뎁스별 데이터
        @param {number} btnShowDepthLength 버튼에 노출할 value값 뎁스 (0이면 전체 뎁스, 0보다 크면 각 뎁스에 해당하는 value값 노출) // TODO. 2뎁스까지 노출하고자 할 때 1, 2 둘다 노출하도록 수정 필요.
        @param {number} maxDepth 최대 뎁스
    */
    setValue(activeData: ActiveDataType, btnShowDepthLength: number) {
        const $strong = this.btnEle?.querySelector('strong');
        if(!$strong) return;

        let btnText = '';

        if(btnShowDepthLength === 0) {
            btnText = activeData.map(v => v?.title).join(' : ');
        } else {
            const active = activeData?.slice(-btnShowDepthLength);
            btnText = active.map(v => v.title).join(' : ');
        }

        $strong.innerText = btnText;
    }
}